import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getScoreColor(score) {
    if (score >= 80)
        return 'text-green-600';
    if (score >= 60)
        return 'text-yellow-600';
    if (score >= 40)
        return 'text-orange-500';
    return 'text-red-600';
}
function getBarColor(score) {
    if (score >= 80)
        return 'bg-green-500';
    if (score >= 60)
        return 'bg-yellow-500';
    if (score >= 40)
        return 'bg-orange-500';
    return 'bg-red-500';
}
function getScoreLabel(score) {
    if (score >= 80)
        return 'Healthy';
    if (score >= 60)
        return 'Fair';
    if (score >= 40)
        return 'At Risk';
    return 'Critical';
}
export const HealthScoreCard = ({ label, score, size = 'md', showBar = true, }) => {
    const sizeClasses = {
        sm: { text: 'text-lg', label: 'text-xs', container: 'p-2' },
        md: { text: 'text-2xl', label: 'text-sm', container: 'p-3' },
        lg: { text: 'text-4xl', label: 'text-base', container: 'p-4' },
    };
    const s = sizeClasses[size];
    return (_jsxs("div", { className: `${s.container}`, children: [_jsxs("div", { className: "flex items-center justify-between mb-1", children: [_jsx("span", { className: `${s.label} font-medium text-gray-600`, children: label }), _jsx("span", { className: `${s.label} font-semibold ${getScoreColor(score)}`, children: getScoreLabel(score) })] }), _jsxs("div", { className: `${s.text} font-bold ${getScoreColor(score)}`, children: [score, _jsx("span", { className: "text-gray-400 text-sm font-normal", children: "/100" })] }), showBar && (_jsx("div", { className: "mt-2 h-2 bg-gray-200 rounded-full overflow-hidden", children: _jsx("div", { className: `h-full rounded-full transition-all ${getBarColor(score)}`, style: { width: `${score}%` } }) }))] }));
};
// Compact inline score badge
export const HealthScoreBadge = ({ score }) => {
    const bgColor = score >= 80 ? 'bg-green-100 text-green-800'
        : score >= 60 ? 'bg-yellow-100 text-yellow-800'
            : score >= 40 ? 'bg-orange-100 text-orange-800'
                : 'bg-red-100 text-red-800';
    return (_jsx("span", { className: `inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${bgColor}`, children: score }));
};
//# sourceMappingURL=HealthScoreCard.js.map